var exports = {
  "kL": "xf0b3b88a--859ec7--container",
  "nM": "xf0b3b88a--859ec7--row",
  "IV": "xf0b3b88a--859ec7--name-container",
  "DD": "xf0b3b88a--859ec7--title",
  "s6": "xf0b3b88a--859ec7--agent-name",
  "z3": "xf0b3b88a--859ec7--credentials",
  "Wl": "xf0b3b88a--859ec7--avatar-container",
  "my": "xf0b3b88a--859ec7--avatar",
  "O0": "xf0b3b88a--859ec7--rating",
  "Bt": "xf0b3b88a--859ec7--rate-value",
  "OK": "xf0b3b88a--859ec7--counters",
  "EB": "xf0b3b88a--859ec7--counters-item",
  "jG": "xf0b3b88a--859ec7--description-container",
  "Lp": "xf0b3b88a--859ec7--about-title",
  "uh": "xf0b3b88a--859ec7--about-text",
  "wI": "xf0b3b88a--859ec7--maximize-button",
  "Vy": "xf0b3b88a--859ec7--rating-column",
};

module.exports = exports;
